import { render, staticRenderFns } from "./SettingFormioView.vue?vue&type=template&id=d615b3e6&scoped=true"
import script from "./SettingFormioView.vue?vue&type=script&lang=js"
export * from "./SettingFormioView.vue?vue&type=script&lang=js"
import style0 from "./SettingFormioView.vue?vue&type=style&index=0&id=d615b3e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d615b3e6",
  null
  
)

export default component.exports